<template>
  <ul class="dom-position">
    <li class="header">
      <span>{{ $t('trade.dom.position'), }}</span>
      <span>{{ $t('trade.dom.cost') }}</span>
      <span>{{ $t('trade.dom.pnl') }}</span>
    </li>
    <li>
      <span>{{ holding.position | largeNumber }}</span>
      <span>{{ averageCost | floatNum(stock) }}</span>
      <span :class="holding.unrealPnl | redGreen">{{
        holding.unrealPnl | largeNumber | sign
      }}</span>
    </li>
  </ul>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PositionList',
  props: {
    holding: Object,
    stock: Object
  },
  computed: {
    ...mapGetters(['isIb']),
    averageCost() {
      if (this.isIb) return this.holding.averageCost / this.holding.multiplier
      return this.holding.averageCost
    }
  }
}
</script>
<style lang="less">
@import '~uikit';
.dom-position {
  flex-shrink: 0;
  margin-bottom: 5px;
  padding: 10px 10px 0;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    margin: 0;
    padding: 0;
    height: 20px;
    &:nth-of-type(2) {
      font-size: 14px;
      font-weight: bold;
      margin-top: 5px;
    }
  }
  span {
    width: 33%;
    flex-shrink: 0;
    flex-grow: 0;
    text-align: left;
  }
  .tt-loading {
    // 覆盖组件自带样式
    width: 30px !important;
    height: 30px !important;
    margin-left: -15px !important;
    margin-top: -10px !important;
  }
}
</style>
